export default "__VITE_ASSET__BpKmqXNv__"